import Vue from 'vue';
import Router from 'vue-router';
import store from '@/admin/js/store';

/**
 * Layzloading will create many files and slow on compiling, so best not to use lazyloading on devlopment.
 * The syntax is lazyloading, but we convert to proper require() with babel-plugin-syntax-dynamic-import
 * @see https://doc.laravue.dev/guide/advanced/lazy-loading.html
 */

Vue.use(Router);

/* Layout */
import Layout from '@/admin/js/layout';

/* Router for modules */
import errorRoutes from './modules/error';
import projectsRoutes from "./modules/projects";
import projectGroupsRoute from './modules/project-groups';
//import statisticRoutes from "./modules/statistic";
import iBotStatistic from "./modules/i-bot-statistic";
import pumpProjectsRoutes from "./modules/pump-projects";
import serviceRoutes from "./modules/service";
import telegramBotMessagesRoutes from "./modules/telegrambot-messages";
import saasQueueRoutes from "./modules/saas-queue";
import help from "./modules/help";
import ticketsRoutes from "./modules/tickets";
import referralRoutes from "./modules/referral";
import widgetRoutes from "./modules/widget";

export const constantRoutes = [
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/redirect/:path*',
                component: () => import('@/admin/js/views/redirect/index'),
            },
        ],
    },
    {
        path: '/login',
        component: () => import('@/admin/js/views/login/index'),
        hidden: true,
    },
    {
        path: '/admin-login',
        component: () => import('@/admin/js/views/admin-login/index'),
        hidden: true,
    },
    {
        path: '/register',
        component: () => import('@/admin/js/views/register/index'),
        hidden: true,
    },
    {
        path: '/auth-redirect',
        component: () => import('@/admin/js/views/login/AuthRedirect'),
        hidden: true,
    },

    {
        path: '/404',
        redirect: { name: 'Page404' },
        component: () => import('@/admin/js/views/error-page/404'),
        hidden: true,
    },
    {
        path: '/401',
        component: () => import('@/admin/js/views/error-page/401'),
        hidden: true,
    },

    widgetRoutes,


    //elementUiRoutes,
];


export const asyncRoutes = [
    {
        path: '/',
        component: Layout,
        redirect: 'profile',
        children: [
            {
                path: 'dashboard',
                redirect: 'profile',
                name: 'Dashboard',
                meta: { title: 'dashboard',  noCache: false },
            },
            {
                path: 'profile',
                component: () => import('@/admin/js/views/user-profile/index'),
                name: 'UserProfile',
                meta: {title: 'Мой аккаунт'},
            },
            {
                path:'users',
                component: () => import('@/admin/js/views/users/index'),
                name: 'Users',
                meta: { title: 'Пользователи',  noCache: false , permissions: ['manage_users']},
            },
            {
                path:'saas',
                component: () => import('@/admin/js/views/saas-admin/index'),
                name: 'SaaS',
                meta: { title: 'SaaS',  noCache: false , permissions: ['manage_users']},
            },
            {
                path:'settings',
                component: () => import('@/admin/js/views/settings/index'),
                name: 'Settings',
                meta: { title: 'Настройки',  noCache: false , permissions: ['manage_users']},
            },
            {
                path:'contacts',
                component: () => import('@/admin/js/views/contacts/index'),
                name: 'Contacts',
                meta: { title: 'Контакты'},
            },
            {
                path: 'profile/transactions',
                component: () => import('@/admin/js/views/transactions/index'),
                name: 'Transactions',
                meta: { title: 'История операций' },
            },
            {
                path: 'profile/payment',
                component: () => import('@/admin/js/views/payments/index'),
                name: 'Payments',
                meta: { title: 'Пополнение баланса' },
            },
            {
                path: 'profile/click-transactions',
                component: () => import('@/admin/js/views/click-transactions/index'),
                name: 'click-transactions',
                meta: { requiresAuth: true }
            },
             {
                path: 'payments',
                component: () => import('@/admin/js/views/admin-payments/index'),
                name: 'AdminPayments',
                meta: { title: 'Платежи',  noCache: false , permissions: ['manage_users', 'manage_payments'] },
            },
        ],
    },
    projectGroupsRoute,
    projectsRoutes,
    //statisticRoutes,
    iBotStatistic,
    saasQueueRoutes,
    errorRoutes,
    pumpProjectsRoutes,
    serviceRoutes,
    telegramBotMessagesRoutes,
    help,
    ticketsRoutes,
    referralRoutes,
    { path: '*', redirect: '/404', hidden: true },
];


const createRouter = () => new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    base: process.env.MIX_LARAVUE_PATH,
    routes: constantRoutes,
});

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

router.beforeEach(async (to, from, next) => {
    // Получаем текущие разрешения пользователя из Vuex
    const userPermissions = store.getters.permissions || [];

    // Проверяем, есть ли у маршрута требуемые права
    if (to.meta.permissions) {
        const hasPermission = to.meta.permissions.some(permission => userPermissions.includes(permission));

        if (!hasPermission) {
            return next('/404'); // Перенаправляем на страницу 404
        }
    }

    next(); // Если всё ок, продолжаем навигацию
});

export default router;
